import React from 'react'
import HeaderDownText from './HeaderDownText'
import HeaderBtn from './HeaderBtn'
import HeaderDownAfter from './HeaderDownAfter'

const HeaderDown = () =>
{
    return (

        <div className='header__down'>
            <HeaderDownText />
            <HeaderBtn />
            <HeaderDownAfter />
        
        </div>

    )

}

export default HeaderDown